<div class="bidding-actions">

  <!-- <div *ngIf="auctionPause && roomdetails.is_me_joined" class="auction-pused">
        <div class="head"> {{"multiAuction.Pause" | translate}} <svg xmlns="http://www.w3.org/2000/svg" width="40"
                height="40" fill="#ffffff" class="bi bi-pause" viewBox="0 0 16 16">
                <path
                    d="M6 3.5a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0V4a.5.5 0 0 1 .5-.5zm4 0a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0V4a.5.5 0 0 1 .5-.5z" />
            </svg> </div>
        <div class="text">{{"multiAuction.Auction pause from Admin" | translate}}</div>
    </div>

  <div *ngIf="itemNotOpen && joind && !auctionPause && roomdetails.remaining_time == 0" class="auction-pused">
    <div class="head"> {{"multiAuction.biddingTime" | translate}}</div>
    <div class="text">{{"multiAuction.biddingTimeTxt" | translate}}</div>
  </div>

    <div *ngIf="auctionWillBeStart && activeAuctionWork == itemDetails?.id && !auctionPause" class="auction-pused">
        <div class="head"> {{"multiAuction.auctionWillBeStart" | translate}}</div>
        <div class="text">{{remainingTimeMinutes}}:{{remainingTimeSeconds}}</div>
    </div> -->


  <app-join-and-withdraw-room (joinSuccefully)="joind = true;roomdetails.is_me_joined = true;userJoined.emit(true)"
    (withdrawSuccefully)="joind = false;roomdetails.is_me_joined = false;itemNotOpen=false;userJoined.emit(false)"
    [roomdetails]="roomdetails"></app-join-and-withdraw-room>
    
  <app-actions-bidding-multi *ngIf="joind && 
    roomdetails.remaining_time <= 0 &&
    !itemDetails?.is_closed &&
    !this.winner &&
    activeAuctionWork == itemDetails?.id && 
    !this.auctionWillBeStart &&
          !auctionPause" [roomdetails]="roomdetails" [itemDetails]="itemDetails"
    [auctionRemainingTime]="auctionRemainingTime" [activeAuctionWork]="activeAuctionWork"
    [auctionRemainingTimeNoBid]="auctionRemainingTimeNoBid" [listBidders]="listBidders"
    (newBidding)="newBiddingListener($event)"></app-actions-bidding-multi>

  <app-auction-winner *ngIf="roomdetails?.is_me_joined && itemDetails?.is_closed && this.winner "
    [lastPrice]="lastPrice"></app-auction-winner>
  <app-auction-not-winner *ngIf="roomdetails?.is_me_joined && itemDetails?.is_closed && !this.winner "
    [lastPrice]="lastPrice"></app-auction-not-winner>

</div>